import { createStorefrontApiClient } from '@shopify/storefront-api-client';

// Make sure we're using the exact domain format Shopify expects
/* Commented out to fix ESLint error - may be needed in future
const formatShopifyDomain = (domain) => {
  if (!domain) return '';
  // Remove any protocol prefix if present
  let formattedDomain = domain.replace(/^https?:\/\//, '');
  // Ensure no trailing slash
  formattedDomain = formattedDomain.replace(/\/$/, '');
  return formattedDomain;
};
*/

// Determine if we're in development mode
const isDevelopment = process.env.NODE_ENV === 'development';

// In development, we'll use a custom fetch function to work around CORS
const customFetch = isDevelopment ? 
  async (url, options) => {
    // For GraphQL requests, use a proxy or mock response in development
    if (url.includes('graphql.json')) {
      console.log('Using development mode for Shopify API request');
      
      // Extract the query from the request body
      const body = JSON.parse(options.body);
      const query = body.query;
      
      // If this is a products query, return mock data
      if (query.includes('products')) {
        console.log('Returning mock product data');
        return new Response(JSON.stringify({
          data: {
            products: {
              edges: []
            }
          }
        }), {
          status: 200,
          headers: {
            'Content-Type': 'application/json'
          }
        });
      }
      
      // For other queries, try the original request
      return fetch(url, options);
    }
    
    // For non-GraphQL requests, use the original fetch
    return fetch(url, options);
  } : undefined;

// IMPORTANT: Use the Shopify store's myshopify.com domain for Storefront API calls,
// not the site domain (ilsprezzatura.com). The site domain now points to Netlify and
// does not host the Shopify GraphQL endpoint.
const SHOPIFY_STORE_DOMAIN =
  process.env.REACT_APP_SHOPIFY_STORE_DOMAIN || 'sprezzatura-dev.myshopify.com';

const client = createStorefrontApiClient({
  storeDomain: SHOPIFY_STORE_DOMAIN,
  publicAccessToken: process.env.REACT_APP_SHOPIFY_STOREFRONT_API_TOKEN,
  apiVersion: '2024-10',
  customFetch: customFetch, // Use our custom fetch in development
  fetchOptions: {
    credentials: 'include', // Include cookies and credentials for cross-origin requests
    headers: {
      'X-Shopify-Storefront-Access-Token': process.env.REACT_APP_SHOPIFY_STOREFRONT_API_TOKEN,
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Origin': window.location.origin
    },
    mode: 'cors'
  }
});

export default client;
